module.exports = __webpack_public_path__ + "static/media/cersei.1227c58b.jpg";